import { useEffect, useLayoutEffect } from 'react';
const isSSR = typeof window === 'undefined' || !window.navigator;
export const useIsomorphicLayoutEffect = isSSR ? useEffect : useLayoutEffect;